import {noop, omit} from "@pg-mono/nodash";
import {getRequest} from "@pg-mono/request";
import {apiV2Link, Scenario} from "@pg-mono/rp-api-routes";

import {clientRpRequestMeta} from "../../../../client/client_rp_request_meta";
import {hitGTMEcommercePurchase} from "../../../offer/tracking/ecommerce_events/hit_gtm_ecommerce_purchase";
import {IOfferDetailApplication} from "../../../offer/types/IOfferDetailApplication";
import {ViewType} from "../../../view_type/ViewType";
import {IApplicationReducerData} from "../../reducers/application_reducer";
import {gtmInquiryOnApplicationSuccess} from "../../tracking/lead/gtm_inquiry_on_application_success";
import {ILeadModalLeadType} from "../../types/lead/ILeadModalLeadType";
import {ApplicationMultiLeadRecommendedPropertyType} from "../../types/multi_lead/ApplicationMultiLeadRecommendedPropertyType";
import {getApplicationSourceSectionDisplay} from "../../utils/form/application_form_source";

const fetchRecommendedPropertyOffer = (offerId: number): Promise<IOfferDetailApplication> => {
    return getRequest(clientRpRequestMeta, apiV2Link.offer.detail(Scenario.OFFER_APPLICATION, {offerId}));
};

export const trackRecommendedPropertiesApplication = (
    applications: ApplicationMultiLeadRecommendedPropertyType[],
    viewType: ViewType | null,
    leadType: ILeadModalLeadType,
    recommendationsWithPriceFilter: boolean,
    sourceSection?: string
): void => {
    // We need to fetch property offer data in order to make GTM event after application submit success
    Promise.all(applications.map(([application]) => fetchRecommendedPropertyOffer(application.offer))).then((offers) => {
        offers.forEach((offer, index) => {
            // Order of response from Promise.all method is preserved, so we can get value from `applications` basing on the index
            const [application, recommendedProperty] = applications[index];

            //GTM purchase event
            const data = {
                offer: {detail: offer},
                vendor: {detail: recommendedProperty.offer.vendor},
                property: {detail: omit(recommendedProperty, ["offer"])}
            } as unknown as IApplicationReducerData;

            const customSourceSection =
                sourceSection || `${getApplicationSourceSectionDisplay(application.source_section)} - ${recommendationsWithPriceFilter ? "low" : "similar"}`;

            gtmInquiryOnApplicationSuccess(application, data, viewType, leadType, true, noop(), customSourceSection);

            hitGTMEcommercePurchase(data, viewType, leadType, customSourceSection, application);
        });
    });
};
import {noop, omit} from "@pg-mono/nodash";
import {getRequest} from "@pg-mono/request";
import {apiV2Link, Scenario} from "@pg-mono/rp-api-routes";

import {clientRpRequestMeta} from "../../../../client/client_rp_request_meta";
import {hitGTMEcommercePurchase} from "../../../offer/tracking/ecommerce_events/hit_gtm_ecommerce_purchase";
import {IOfferDetailApplication} from "../../../offer/types/IOfferDetailApplication";
import {ViewType} from "../../../view_type/ViewType";
import {IApplicationReducerData} from "../../reducers/application_reducer";
import {gtmInquiryOnApplicationSuccess} from "../../tracking/lead/gtm_inquiry_on_application_success";
import {ILeadModalLeadType} from "../../types/lead/ILeadModalLeadType";
import {ApplicationMultiLeadRecommendedPropertyType} from "../../types/multi_lead/ApplicationMultiLeadRecommendedPropertyType";
import {getApplicationSourceSectionDisplay} from "../../utils/form/application_form_source";

const fetchRecommendedPropertyOffer = (offerId: number): Promise<IOfferDetailApplication> => {
    return getRequest(clientRpRequestMeta, apiV2Link.offer.detail(Scenario.OFFER_APPLICATION, {offerId}));
};

export const trackRecommendedPropertiesApplication = (
    applications: ApplicationMultiLeadRecommendedPropertyType[],
    viewType: ViewType | null,
    leadType: ILeadModalLeadType,
    recommendationsWithPriceFilter: boolean,
    sourceSection?: string
): void => {
    // We need to fetch property offer data in order to make GTM event after application submit success
    Promise.all(applications.map(([application]) => fetchRecommendedPropertyOffer(application.offer))).then((offers) => {
        offers.forEach((offer, index) => {
            // Order of response from Promise.all method is preserved, so we can get value from `applications` basing on the index
            const [application, recommendedProperty] = applications[index];

            //GTM purchase event
            const data = {
                offer: {detail: offer},
                vendor: {detail: recommendedProperty.offer.vendor},
                property: {detail: omit(recommendedProperty, ["offer"])}
            } as unknown as IApplicationReducerData;

            const customSourceSection =
                sourceSection || `${getApplicationSourceSectionDisplay(application.source_section)} - ${recommendationsWithPriceFilter ? "low" : "similar"}`;

            gtmInquiryOnApplicationSuccess(application, data, viewType, leadType, true, noop(), customSourceSection);

            hitGTMEcommercePurchase(data, viewType, leadType, customSourceSection, application);
        });
    });
};
